import { useState } from "react";
import { supa } from "./firebase";

function ModalInfoPersonalTrainer({ personalTrainer, setVisible, aggiorna }) {
    const [name, setName] = useState(personalTrainer.nome);
    const [surname, setSurname] = useState(personalTrainer.cognome);
    const [birth, setBirth] = useState(personalTrainer.birth);
    const [notes, setNotes] = useState(personalTrainer.note);
    const [retribuzione, setRetribuzione] = useState(personalTrainer.costo);

    async function patchPersonalTrainer() {
        const { data, error } = await supa
            .from('personalTrainer')
            .update({ "id": personalTrainer.id, "nome": name, "cognome": surname, "birth": birth, "note": notes, "costo": retribuzione })
            .eq('id', personalTrainer.id)
        if (error) console.log(error)
            console.log(data)
        aggiorna()
        setVisible(false)
    }

    async function deletePersonalTrainer() {
        const { data, error } = await supa
            .from('personalTrainer')
            .delete()
            .eq('id', personalTrainer.id)
        if (error) {console.log(error); alert("Errore nell'eliminazione del personal trainer, il personal trainer potrebbe essere associato a delle lezioni")}   
            else{
            aggiorna()
            setVisible(false)
            }
    }

    const alertDelete = () => {
        if (window.confirm(`Sei sicuro di voler eliminare ${personalTrainer.nome} ${personalTrainer.cognome}?`)) {
            deletePersonalTrainer()
        }
    }

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
            <div className="relative w-full max-w-2xl mx-4 animate-in fade-in zoom-in duration-200">
                <div className="relative bg-white rounded-2xl shadow-2xl border border-zinc-200">
                    {/* Header */}
                    <div className="flex items-center justify-between p-6 border-b border-zinc-200">
                        <div>
                            <h3 className="text-2xl font-bold text-zinc-900">Info Personal Trainer</h3>
                            <p className="text-sm text-zinc-600 mt-1">Modifica le informazioni del trainer</p>
                        </div>
                        <button 
                            onClick={() => setVisible(false)} 
                            className="p-2 text-zinc-400 hover:text-zinc-600 hover:bg-zinc-100 rounded-lg transition-all"
                        >
                            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    {/* Body */}
                    <form className="p-6">
                        <div className="grid gap-6 mb-6 md:grid-cols-2">
                            <div>
                                <label className="block mb-2 text-sm font-semibold text-zinc-700">Nome</label>
                                <input 
                                    type="text" 
                                    value={name} 
                                    onChange={(e) => setName(e.target.value)} 
                                    className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all" 
                                    placeholder="Inserisci nome"
                                />
                            </div>
                            <div>
                                <label className="block mb-2 text-sm font-semibold text-zinc-700">Cognome</label>
                                <input 
                                    type="text" 
                                    value={surname} 
                                    onChange={(e) => setSurname(e.target.value)} 
                                    className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all" 
                                    placeholder="Inserisci cognome"
                                />
                            </div>
                            <div>
                                <label className="block mb-2 text-sm font-semibold text-zinc-700">Data di Nascita</label>
                                <input 
                                    type="date" 
                                    value={birth} 
                                    onChange={(e) => setBirth(e.target.value)} 
                                    className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all"
                                />
                            </div>
                            <div>
                                <label className="block mb-2 text-sm font-semibold text-zinc-700">Costo per Lezione (€)</label>
                                <input 
                                    type="number" 
                                    value={retribuzione}  
                                    onChange={(e) => setRetribuzione(e.target.value)} 
                                    className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all" 
                                    placeholder="0.00"
                                />
                            </div>
                            <div className="md:col-span-2">
                                <label className="block mb-2 text-sm font-semibold text-zinc-700">Eventuali Note</label>
                                <textarea 
                                    onChange={(e) => setNotes(e.target.value)} 
                                    rows="4"
                                    className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all resize-none" 
                                    placeholder="Inserisci note..."
                                ></textarea>
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="flex items-center justify-between gap-3 pt-4 border-t border-zinc-200">
                            <button 
                                type="button"
                                onClick={() => patchPersonalTrainer()}
                                className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-semibold text-zinc-900 bg-yellow-400 hover:bg-yellow-500 rounded-xl shadow-sm hover:shadow transition-all"
                            >
                                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                </svg>
                                Salva Modifiche
                            </button>
                            <button 
                                type="button"
                                onClick={() => alertDelete()}
                                className="px-5 py-2.5 text-sm font-semibold text-white bg-red-500 hover:bg-red-600 rounded-xl transition-all"
                            >
                                Elimina
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default ModalInfoPersonalTrainer;
